import React from "react";
import FavoriteIcon from "@mui/icons-material/Favorite";
import { Typography } from "@mui/material";

export default function WithLove() {
  return (
    <Typography
      variant="body2"
      textAlign="center"
      sx={{ display: "flex", justifyContent: "center", pt: 4 }}
    >
      With <FavoriteIcon fontSize="small" color="primary" /> from Gadites tech
      team
    </Typography>
  );
}
